var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("validation-observer", {
    ref: "EditForm",
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (ref) {
          var invalid = ref.invalid
          return [
            _c(
              "b-form",
              {
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _vm.editTask()
                  },
                },
              },
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { md: "12" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Title",
                              "label-for": "task_title",
                            },
                          },
                          [
                            _c("validation-provider", {
                              attrs: {
                                name: "Title",
                                vid: "Title",
                                rules: "required",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-input", {
                                          attrs: {
                                            id: "task_title",
                                            placeholder: "Title",
                                            required: "",
                                            disabled: _vm.isView,
                                          },
                                          model: {
                                            value: _vm.task.title,
                                            callback: function ($$v) {
                                              _vm.$set(_vm.task, "title", $$v)
                                            },
                                            expression: "task.title",
                                          },
                                        }),
                                        _c(
                                          "small",
                                          { staticClass: "text-danger" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "4" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Milestone",
                              "label-for": "milestones",
                            },
                          },
                          [
                            _c("b-form-select", {
                              attrs: {
                                id: "milestones",
                                disabled:
                                  _vm.isView || _vm.currentMilestoneId != null,
                                options: _vm.milestonesList,
                              },
                              on: { change: _vm.selectedMilestone },
                              model: {
                                value: _vm.task.milestonesId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.task, "milestonesId", $$v)
                                },
                                expression: "task.milestonesId",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "4" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Start Date",
                              "label-for": "start_date",
                            },
                          },
                          [
                            _c("validation-provider", {
                              attrs: {
                                name: "State Date",
                                vid: "Start Date",
                                rules: "required",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-datepicker", {
                                          staticClass: "mb-1",
                                          attrs: {
                                            id: "start_date",
                                            disabled: _vm.isView,
                                            "date-format-options": {
                                              day: "2-digit",
                                              month: "short",
                                              year: "numeric",
                                            },
                                          },
                                          model: {
                                            value: _vm.task.startDate,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.task,
                                                "startDate",
                                                $$v
                                              )
                                            },
                                            expression: "task.startDate",
                                          },
                                        }),
                                        _c(
                                          "small",
                                          { staticClass: "text-danger" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "4" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "End Date",
                              "label-for": "end_date",
                            },
                          },
                          [
                            _c("validation-provider", {
                              attrs: {
                                name: "End Date",
                                vid: "End Date",
                                rules: "required",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-datepicker", {
                                          attrs: {
                                            id: "end_date",
                                            min: _vm.task.startDate,
                                            placeholder: "Choose a date",
                                            disabled: _vm.isView,
                                            "date-format-options": {
                                              day: "2-digit",
                                              month: "short",
                                              year: "numeric",
                                            },
                                          },
                                          model: {
                                            value: _vm.task.endDate,
                                            callback: function ($$v) {
                                              _vm.$set(_vm.task, "endDate", $$v)
                                            },
                                            expression: "task.endDate",
                                          },
                                        }),
                                        _c(
                                          "small",
                                          { staticClass: "text-danger" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "4" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Assignee",
                              "label-for": "assignee",
                            },
                          },
                          [
                            _c("validation-provider", {
                              attrs: {
                                name: "Assignee",
                                vid: "Assignee",
                                rules: "required",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c("b-form-select", {
                                          attrs: {
                                            options: _vm.assignee_options,
                                            disabled: _vm.isView,
                                          },
                                          model: {
                                            value: _vm.task.assignee,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.task,
                                                "assignee",
                                                $$v
                                              )
                                            },
                                            expression: "task.assignee",
                                          },
                                        }),
                                        _c(
                                          "small",
                                          { staticClass: "text-danger" },
                                          [_vm._v(_vm._s(errors[0]))]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "4" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Priority",
                              "label-for": "priority",
                            },
                          },
                          [
                            _c("b-form-select", {
                              attrs: {
                                options: _vm.priorityOptions,
                                required: "",
                                disabled: _vm.isView,
                              },
                              model: {
                                value: _vm.task.priority,
                                callback: function ($$v) {
                                  _vm.$set(_vm.task, "priority", $$v)
                                },
                                expression: "task.priority",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "4" } },
                      [
                        _c(
                          "b-form-group",
                          { attrs: { label: "Status", "label-for": "status" } },
                          [
                            _c("b-form-select", {
                              attrs: {
                                options: _vm.statusOptions,
                                required: "",
                                disabled: _vm.isView,
                              },
                              model: {
                                value: _vm.task.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.task, "status", $$v)
                                },
                                expression: "task.status",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "12" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: "Comment",
                              "label-for": "task_description",
                            },
                          },
                          [
                            _c("b-form-textarea", {
                              attrs: {
                                id: "task_description",
                                placeholder: "Comment",
                                rows: "3",
                                disabled: _vm.isView,
                              },
                              model: {
                                value: _vm.task.description,
                                callback: function ($$v) {
                                  _vm.$set(_vm.task, "description", $$v)
                                },
                                expression: "task.description",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    !_vm.isView
                      ? _c(
                          "b-col",
                          {
                            staticClass: "d-flex justify-content-between",
                            attrs: { md: "12" },
                          },
                          [
                            _c(
                              "b-button",
                              {
                                attrs: { type: "button", variant: "primary" },
                                on: { click: _vm.editTask },
                              },
                              [_vm._v("Submit")]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }